<input type="checkbox" :value="uniqueKey" v-model="checked" @change="onChange($event.target.value)" @click="onClick($event.target.checked)">